/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_No_ClientsInputs */

const en_users_form_no_clients = /** @type {(inputs: Users_Form_No_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No clients found.`)
};

const pt_br2_users_form_no_clients = /** @type {(inputs: Users_Form_No_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum cliente encontrado.`)
};

/**
* | output |
* | --- |
* | "No clients found." |
*
* @param {Users_Form_No_ClientsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_no_clients = /** @type {((inputs?: Users_Form_No_ClientsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_No_ClientsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_no_clients(inputs)
	return pt_br2_users_form_no_clients(inputs)
});